import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IwipService {

  private iwipUrl = "https://nednr.nebraska.gov/IwipApi/";

  private stationListSource = new BehaviorSubject<Station[]>([]);
  stationList = this.stationListSource.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  getStationList() {
    this.http.get<GetStationListResponse>(`${this.iwipUrl}api/v1/StreamGage/GetStationList`).subscribe(
      response => {
        if (!!response && response.RecordCount > 0) {
          this.stationListSource.next(response.Results);
        }
      },
      error => console.error(error)
    );
  }

}

export interface GetStationListResponse {
  RecordCount: number,
  Results: Station[]
}

export interface Station {
  StationName: string,
  SourceName: string,
  StationNumber: string,
  RiverBasin: string,
  FieldOffice: string,
  StationTypeDescription: string,
  DownStream: number,
  TimeZone: string,
  Elevation: number,
  ElevationUnits: string,
  Longitude: number,
  Latitude: number,
  IsActive: boolean
}
